export default "__VITE_ASSET__d991e460__"